module.exports = __webpack_public_path__ + "static/4-96e6c4b28c5426450acb8b648c471d0a.png";